export class CoreConstants {

  static readonly APP_SECRET_KEY = 'RpGMFiMmugLdHzPekwcNUGP71PRfGFUR2t9sPGwXw38rxk2f';

  // Regular Expressions Patterns
  static readonly REGEX_EMAIL = new RegExp(/^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/);
  static readonly REGEX_PASSWORD_STRENGTH = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})$/);
  static readonly REGEX_PASSWORD = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/);
  static readonly REGEX_IMAGE_EXTENSIONS = new RegExp(/\.(jpg|jpeg|png)$/);
  static readonly REGEX_EXCEL_FILE_EXTENSIONS = new RegExp(/\.(xls|xlsx|csv)$/);

  static readonly ACCEPT_EXCEL_OR_CSV_FILE = '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';


  static readonly Status = {
    active: {
      key: 'ACTIVE',
      labelKey: 'generic.label.status.active'
    },
    inactive: {
      key: 'INACTIVE',
      labelKey: 'generic.label.status.inactive'
    },
    pending: {
      key: 'PENDING',
      labelKey: 'generic.label.status.pending'
    }
  }

  static readonly Priority = {
    one: {
      value: 1,
      label: "priority 1"
    },
    two: {
      value: 2,
      label: "priority 2"
    },
    three: {
      value: 3,
      label: "priority 3"
    }
  }
  
  static readonly Data = {
    table: {
      paginator: {
        rows: 10,
        rowsPerPageOptions: [10, 20, 50]
      }
    },
    grid: {
      paginator: {
        rows: 9,
        rowsPerPageOptions: [9, 20, 50]
      }
    }
  
  }

  static readonly ImageCropper = {
    rotation: {
      forward: 90,
      reverse: -90
    }
  }

}